import { useQuery } from '@tanstack/react-query';
import { getPayrollSettings } from './getPayrollSettings';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { mockedPayrollSettings } from './mock';
import { PayrollSettingsQueryModel } from './types';
import { QUERY_KEY_SETTINGS_PAYROLL, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

type Props = {
  companyId: string
}

/**
 * Fetches available countries.
 */
export function useQueryPayrollSettings(props: Props) {
  const { companyId } = props
  return useQuery<PayrollSettingsQueryModel>({
    queryKey: [QUERY_KEY_SETTINGS_PAYROLL, companyId],
    queryFn: async () => {
      if (COMPANY_API_SETTINGS_MOCKED) {
        return mockedPayrollSettings
      }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getPayrollSettings(props);
      return data;
    },
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
